
import React, { Component } from 'react';
import { Modal,  Button, Progress } from 'antd';


import { fixedNumber } from '../../../util/util';

class RentSumDetail extends Component {

    state = {}

    createDom = (data) => {

    };

    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={600}
                visible={visible}
                title={editData.month + " " + editData.orgName + " 收费情况"}
                okText=""
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <style>
                    {
                        `
                        .detail-table{width: 100%; }
                        .detail-table td{text-align: right;padding: 5px; border: 1px solid #e8e8e8;}
                        .detail-table tr>td:nth-child(1),
                        .detail-table tr:nth-child(1)>td
                        {background-color: #fafafa; text-align: center;}
                        `
                    }
                </style>
                <table className='detail-table'>
                    <tbody>
                        <tr>
                            <td style={{width: '80px'}}></td>
                            <td style={{width: '150px'}}>应收</td>
                            <td style={{width: '150px'}}>已收</td>
                            <td style={{width: '220px'}}>占比</td>
                        </tr>
                        <tr>
                            <td>租金</td>
                            <td>{editData["totalRentFees"]}</td>
                            <td>{editData["rentFeesCharge"]}</td>
                            <td>
                                <Progress percent={fixedNumber((editData["rentFeesCharge"] / editData["totalRentFees"] * 100).toFixed(2), 2)} />
                            </td>
                        </tr>
                        <tr>
                            <td>物业费</td>
                            <td>{editData["totalPropertyFees"]}</td>
                            <td>{editData["propertyFeesCharge"]}</td>
                            <td>
                                <Progress percent={fixedNumber((editData["propertyFeesCharge"] / editData["totalPropertyFees"] * 100).toFixed(2), 2)} />
                            </td>
                        </tr>
                        <tr>
                            <td>水费</td>
                            <td>{editData["waterFees"]}</td>
                            <td>{editData["waterFeesCharge"]}</td>
                            <td>
                                <Progress percent={fixedNumber((editData["waterFeesCharge"] / editData["waterFees"] * 100).toFixed(2), 2)} />
                            </td>
                        </tr>
                        <tr>
                            <td>电费</td>
                            <td>{editData["electricityFees"]}</td>
                            <td>{editData["electricityFeesCharge"]}</td>
                            <td>
                                <Progress percent={fixedNumber((editData["electricityFeesCharge"] / editData["electricityFees"] * 100).toFixed(2), 2)} />
                            </td>
                        </tr>
                        <tr>
                            <td>合计</td>
                            <td>{editData["totalFees"]}</td>
                            <td>{editData["chargedFees"]}</td>
                            <td>
                                <Progress percent={fixedNumber((editData["chargedFees"] / editData["totalFees"] * 100).toFixed(2), 2)} />
                            </td>
                        </tr>
                        <tr>
                            <td>客户数</td>
                            <td>{editData["memberNumber"]}</td>
                            <td>{editData["chargedNumber"]}</td>
                            <td>
                                <Progress percent={fixedNumber((editData["chargedNumber"] / editData["memberNumber"] * 100).toFixed(2), 2)} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Modal>
        );
    }
}


export default RentSumDetail;